import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';
import Vue from 'vue';

export const mutations: MutationTree<any> = {
  // 查询课程类型
  [TYPES.COURSE_TYPES.REQUEST](state: IState) {
    state.courseTypes.loading = true;
  },
  [TYPES.COURSE_TYPES.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    for (const item of data) {
      item.categoryValue = item.categoryId.toString();
    }
    state.courseTypes.loading = false;
    state.courseTypes.infos = [
      {
        categoryId: '',
        categoryName: '全部',
        categoryValue: '',
        sort: '1'
      },
      ...data
    ];
  },
  [TYPES.COURSE_TYPES.FAILED](state: IState) {
    state.courseTypes.infos = [];
    state.courseTypes.loading = false;
  },

  // 搜索课程
  [TYPES.COURSE_CATEGORY.REQUEST](state: IState) {
    state.courseCategory.loading = true;
  },
  [TYPES.COURSE_CATEGORY.SUCCESS](state: IState, payload) {
    const data = payload.res.Data;
    state.courseCategory.result = data;
    state.courseCategory.loading = false;
  },
  [TYPES.COURSE_CATEGORY.FAILED](state: IState) {
    state.courseCategory.result = {};
    state.courseCategory.loading = false;
  },

  // 获取课程详情
  [TYPES.COURSE_INFO.REQUEST](state: IState) {
    state.courseInfo.loading = true;
  },
  [TYPES.COURSE_INFO.SUCCESS](state: IState, payload) {
    state.courseInfo.loading = false;
    const data = payload.res.Data;
    state.courseInfo.result = data;

  },
  [TYPES.COURSE_INFO.FAILED](state: IState) {
    state.courseInfo.result = {};
    state.courseInfo.loading = false;
  },

  // 获取课程评分
  [TYPES.COURSE_SCORE.REQUEST](state: IState) {
    state.courseScore.loading = true;
  },
  [TYPES.COURSE_SCORE.SUCCESS](state: IState, payload) {
    state.courseScore.loading = false;
    const data = payload.res.Data;
    state.courseScore.result = data;
  },
  [TYPES.COURSE_SCORE.FAILED](state: IState) {
    state.courseScore.loading = false;
  },

  // 打分
  [TYPES.COURSE_SCORE_SET.REQUEST](state: IState) {
    state.courseScoreSet = true;
  },
  [TYPES.COURSE_SCORE_SET.SUCCESS](state: IState, payload) {
    state.courseScoreSet = false;
    Message({
      message: '打分成功了哦！',
      type: 'success'
    });
  },
  [TYPES.COURSE_SCORE_SET.FAILED](state: IState) {
    state.courseScoreSet = false;
  },

  // 课程已看
  [TYPES.COURSE_PLAYED.REQUEST](state: IState) {
  },
  [TYPES.COURSE_PLAYED.SUCCESS](state: IState, payload) {
  },
  [TYPES.COURSE_PLAYED.FAILED](state: IState) {
  },

  // 提交反馈
  [TYPES.COURSE_FEEDBACK.REQUEST](state: IState) {
    state.courseFeedback = true;
  },
  [TYPES.COURSE_FEEDBACK.SUCCESS](state: IState, payload) {
    state.courseFeedback = false;
    Message({
      message: '谢谢您的反馈！',
      type: 'success'
    });
  },
  [TYPES.COURSE_FEEDBACK.FAILED](state: IState) {
    state.courseFeedback = false;
  }
};
